import { buildPaths } from '@front/logic/others/buildPaths'

const ErrorRoutes = buildPaths({
  Error: {
    Forbidden: {},
    Server: {},
    NotFound: {},
    Internal: {},
    ExpiredOffer: {},
  },
})

export const ErrorRoutesVariables = {
  ForbiddenError: ErrorRoutes.Error.Forbidden.path,
  ServerError: ErrorRoutes.Error.Server.path,
  NotFoundError: ErrorRoutes.Error.NotFound.path,
  InternalError: ErrorRoutes.Error.Internal.path,
  ExpiredOfferError: ErrorRoutes.Error.ExpiredOffer.path,
}
